import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
import { HashiGameStateModel } from './hashi-game-states.model';
import * as actions from './hashi-game.actions';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';

// @dynamic
@State<HashiGameStateModel>({
  name: 'hashiGameStates',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class HashiGameState extends PuzzleGameBaseState {
  @Action(actions.InitHashiGame)
  InitHashiGame(state: StateContext<HashiGameStateModel>, { payload }: actions.InitHashiGame) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistHashiState)
  PersistHashiState(state: StateContext<HashiGameStateModel>, { payload }: actions.PersistHashiState) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            bridges: payload.bridges,
          }),
        }),
      })
    );
  }
}
